import { NodeType } from '@amplify/amp-module';
import NodeHandlerBase from '../node-handler-base';

export default class CarouselHandler extends NodeHandlerBase {
  constructor(ctx) {
    super(ctx, NodeType.carousel);
  }
}
